module.exports = __webpack_public_path__ + "front/img/z1.04857093.jpg";